import { ajax } from "services/ajax";
import { map, switchMap, take } from "rxjs/operators";
import { jsonHeaders$ } from "./subjects";
import { UpdateMailingAddressRequest } from "interfaces/api/member/UpdateMailingAddressRequest";
import { UpdateMemberContactInformationRequest } from "interfaces/api/member/UpdateContactInformationRequest";

export const accountInformationService = {
  updateContactInformation$: (data: UpdateMemberContactInformationRequest) =>
    jsonHeaders$.pipe(
      take(1),
      switchMap((headers) =>
        ajax<boolean>({
          method: "POST",
          url: "api/member/updateMemberContactInformation",
          headers,
          body: data,
        }).pipe(map((response) => response))
      )
    ),
    updateMailingAddress$: (data: UpdateMailingAddressRequest) =>
    jsonHeaders$.pipe(
      take(1),
      switchMap((headers) =>
        ajax<boolean>({
          method: "POST",
          url: "api/member/updateMemberMailingAddress",
          headers,
          body: data,
        }).pipe(map((response) => response))
      )
    ),
};
